export class RunAsyncUntilCompleteTimedOutError extends Error {
  public timeoutMs: number;

  constructor(timeoutMs: number) {
    super(`Async request timed out out after ${timeoutMs / 1000} seconds`);
    this.timeoutMs = timeoutMs;
  }
}
